// Canonical public domain for shareable job links — always infocityjobs.com,
// even when running from a preview/dev environment (never share a preview URL).
export const PUBLIC_SITE_URL = "https://infocityjobs.com";

export function buildJobShareUrl(jobId) {
  return `${PUBLIC_SITE_URL}/jobs/${jobId}`;
}

export function buildJobShareMessage(job, locationText, introText) {
  const lines = [job.title, job.company_name, locationText, introText, buildJobShareUrl(job.job_id)].filter(Boolean);
  return lines.join("\n");
}

/** Opens the device's NATIVE share sheet (AirDrop/Messages/Mail/WhatsApp/etc. —
 * whatever the OS/browser offers) via the Web Share API. WhatsApp is never
 * chosen automatically; it's just one of the apps the OS may list. Falls back
 * to copying the link to the clipboard when navigator.share isn't available
 * (older desktop browsers) or when the user's device has nothing to share to.
 * A cancelled/dismissed share sheet (AbortError) is normal user behavior, not
 * an app error — it's silently ignored, no toast, no retry, no fallback. */
export async function shareJob(job, locationText, introText, onLinkCopied) {
  const url = buildJobShareUrl(job.job_id);
  const text = [job.title, job.company_name, locationText].filter(Boolean).join("\n");
  if (navigator.share) {
    try {
      await navigator.share({ title: job.title, text, url });
    } catch (err) {
      if (err && err.name === "AbortError") return; // user cancelled — not an error
      await copyJobLink(job, locationText, introText, onLinkCopied);
    }
    return;
  }
  await copyJobLink(job, locationText, introText, onLinkCopied);
}

async function copyJobLink(job, locationText, introText, onLinkCopied) {
  const message = buildJobShareMessage(job, locationText, introText);
  try {
    await navigator.clipboard.writeText(message);
    if (onLinkCopied) onLinkCopied();
  } catch {
    // Clipboard API unavailable/denied — nothing else safe to do here.
  }
}
